import LazyLoad from "vanilla-lazyload";

class LazyLoadInnit {
    constructor() {
		let lazyLoadImg = new LazyLoad({
			elements_selector: "img[data-src]",
		});
		let lazyLoadBg = new LazyLoad({
			elements_selector: "[data-bg]",
		});
    }
}

export default new LazyLoadInnit;
